import { useModel as _useModel, useSlots as _useSlots, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, useAttrs, watchEffect } from 'vue'
import {
  useCurrencyInput,
  type CurrencyDisplay,
  type CurrencyInputOptions,
  type NumberRange
} from 'vue-currency-input'
import { type VTextField } from 'vuetify/components'

interface Props {
  /** Minimum allowed value */
  min?: NumberRange['min']
  /** Maximum allowed value */
  max?: NumberRange['max']
  /** Number of decimal places */
  precision?: CurrencyInputOptions['precision']
  /** How to display the currency symbol */
  currencyDisplay?: CurrencyDisplay
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'MoneyField'
},
  __name: 'MoneyField',
  props: /*@__PURE__*/_mergeModels({
    min: { default: () => (undefined) },
    max: { default: () => (undefined) },
    precision: { default: 2 },
    currencyDisplay: { default: 'symbol' as CurrencyDisplay }
  }, {
    "modelValue": {
  validator: () => true
},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['change'], ["update:modelValue"]),
  setup(__props: any) {



// Gets emitted by currency input composable
// eslint-disable-next-line vue/no-unused-emit-declarations




const model = _useModel(__props, "modelValue")

const currencyOptions = computed<CurrencyInputOptions>(() => ({
  currency: 'EUR',
  locale: 'fr-FR',
  precision: __props.precision,
  valueRange: { min: __props.min, max: __props.max },
  currencyDisplay: __props.currencyDisplay
}))

const { inputRef, setValue, formattedValue, setOptions } = useCurrencyInput(
  // eslint-disable-next-line vue/no-ref-object-reactivity-loss
  currencyOptions.value
)

watchEffect(() => {
  setOptions(currencyOptions.value)
})

watchEffect(() => {
  setValue(model.value)
})

const attrs: VTextField['$props'] = useAttrs()

const slots = _useSlots()

return (_ctx: any,_cache: any) => {
  const _component_VTextField = _resolveComponent("VTextField")!

  return (_openBlock(), _createBlock(_component_VTextField, {
    ref_key: "inputRef",
    ref: inputRef,
    modelValue: _unref(formattedValue),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(formattedValue) ? (formattedValue).value = $event : null)),
    "aria-label": _unref(attrs).label
  }, _createSlots({ _: 2 }, [
    _renderList(Object.keys(slots), (slot, index) => {
      return {
        name: slot,
        fn: _withCtx(() => [
          _renderSlot(_ctx.$slots, slot)
        ])
      }
    })
  ]), 1032, ["modelValue", "aria-label"]))
}
}

})